<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
    >
      <template slot="left" >
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-tools</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ToolHeadForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <template>
      <div class="toolheadsub-list">
        <Toolbar
          :handle-add="() => addHandlerSub('ToolHeadSub',item)"
        />
        <v-container grid-list-xl fluid>
          <v-layout row wrap>
            <v-flex sm12 >
              <h2>{{$t('profile.tool.toolheadssub')}}</h2>
            </v-flex>
            <v-flex lg12>
              <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
                <ToolHeadSubFilterForm
                  ref="filterForm"
                  :values="filters"
                  slot="filter"
                />
              </DataFilter>

              <br />

              <v-data-table
                v-model="selected"
                :headers="headers"
                :items="itemsSub"
                :loading="isLoading"
                :loading-text="$t('global.loading')"
                :options.sync="options"
                :server-items-length="totalItems"
                class="elevation-1"
                item-key="@id"
                show-select
                @update:options="onUpdateOptions"
@click:row="editHandlerSubEvent"
              >
                    <template slot="item.inputQuantity" slot-scope="{ item }">
                      {{ $n(item['inputQuantity']) }}
                    </template>
                    <template slot="item.outputQuantity" slot-scope="{ item }">
                      {{ $n(item['outputQuantity']) }}
                    </template>
                    <template slot="item.tools" slot-scope="{ item }">
                      <ul>
                        <li v-for="tool in item['tools']" :key="tool.id">
                          {{ tool.name }}
                        </li>
                      </ul>
                    </template>

                <ActionCell
                slot="item.action"
                slot-scope="props"
                :handle-edit="() => editHandlerSub(item,'ToolHeadSub',props.item)"
                ></ActionCell>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </template>
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ToolHeadForm from '../../components/toolhead/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ToolHeadSubFilterForm from '../../components/toolheadsub/Filter';
import DataFilter from '../../components/DataFilter';

const servicePrefix = 'ToolHead';

export default {
  name: 'ToolHeadUpdate',
  servicePrefix,
  components: {
    Loading,
    Toolbar,
    ToolHeadForm,
    ActionCell,
    ToolHeadSubFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.tool.inputquantity'), value: 'inputQuantity' },
        { text: this.$t('profile.tool.outputquantity'), value: 'outputQuantity' },
        { text: this.$t('profile.tool.heater'), value: 'heater' },
        { text: this.$t('profile.tool.model'), value: 'model' },
        { text: this.$t('profile.tool.optionsubtool'), value: 'optionSubTool' },
        { text: this.$t('profile.tool.materialmedium'), value: 'materialMedium.name' },
        { text: this.$t('profile.tool.materialfeedspec'), value: 'materialFeedSpec.name' },
        { text: this.$t('profile.tool.nozzletype'), value: 'nozzleType.name' },
        { text: this.$t('profile.tool.tools'), value: 'tools' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      filters: { 'toolHead' : this.$route.params.id},
      selected: []
    };
  },
  mixins: [ListMixin,UpdateMixin],
  computed: {
    ...mapFields('toolhead', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('toolhead', ['find']),
    ...mapFields('toolheadsub', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    ...mapGetters('toolheadsub', {
          itemsSub: 'list'
    }),

  },

  methods: {
    ...mapActions('toolhead', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    }),
    ...mapActions('toolheadsub', {
      getPage: 'fetchAll',
    }),
    editHandlerSubEvent(value) {
      this.editHandlerSub(this.item,'ToolHeadSub',value);
    }
  }
};
</script>
